import {Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
  selector: 'app-correction-fixed-staff-member',
    imports: [
        WaButtonDirective,
        WaIconDirective
    ],
  templateUrl: './correction-fixed-staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './correction-fixed-staff-member.component.scss',
})
export class CorrectionFixedStaffMemberComponent {

  staffmember = input.required<StaffMember>();
  @Output() unfix = new EventEmitter<StaffMember>();

}
